import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-slider--right",
  "use": "icon-slider--right-usage",
  "viewBox": "0 0 14 12",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 12\" id=\"icon-slider--right\"><path d=\"M8.998.928a.909.909 0 1 0-1.286 1.287l2.932 2.932-9.36.014a.909.909 0 0 0 .004 1.818l9.384-.01-2.955 2.956a.909.909 0 1 0 1.285 1.285L13.5 6.713a.91.91 0 0 0-.004-1.287L8.998.928Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol